import {Route} from 'react-router'
import {ApiConsumerDetails, ApiConsumers, NewApiConsumer} from './api'
import {EnvironmentsMap} from './environments_map'
import {FinancialDashboard, LeadsDashboard} from './dashboard'
import {RecordsRoute} from '~/routing/components'

export const routes = (
	<>
		<Route path="/data">
			<Route element={<RecordsRoute awaitRecords={['environments']} placeholderProps={{name: 'map', animation: 'location'}} />}>
				<Route path="map" element={<EnvironmentsMap />} />
			</Route>
			<Route path="graphs">
				<Route path="financial" element={<FinancialDashboard />} />
				<Route path="leads" element={<LeadsDashboard />} />
			</Route>
		</Route>
		<Route path="/api_consumers">
			<Route element={<RecordsRoute awaitRecords={['apiConsumers']} />}>
				<Route index element={<ApiConsumers />} />
				<Route path="new" element={<NewApiConsumer />} />
				<Route path=":id" element={<ApiConsumerDetails />} />
			</Route>
		</Route>
	</>
)
